import React from 'react'
import { FormattedMessage } from 'react-intl'

import { INDUSTRIAL_RESOURCE_MULTIPLIER } from 'helpers/i18n'

import styles from './IndustrialResourceCoefTooltip.scss'


export const INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT = (multiplier) => (
    <FormattedMessage
        id='industrial_resource.multiplier.tooltip'
        defaultMessage='Клан получает {multiplierElement} к промресурсу за бои в Вылазках и Наступлениях, а также по результатам Наступлений.' // eslint-disable-line max-len
        values={{
            multiplierElement: (
                <span className={styles.highlight}>{INDUSTRIAL_RESOURCE_MULTIPLIER(multiplier)}</span>
            ),
        }}
    />
)



// WEBPACK FOOTER //
// ./components/IndustrialResourceCoefTooltip/constants.jsx